import { render, staticRenderFns } from "./receipt-detail.vue?vue&type=template&id=7f1724f6&scoped=true"
import script from "./receipt-detail.vue?vue&type=script&lang=js"
export * from "./receipt-detail.vue?vue&type=script&lang=js"
import style0 from "./receipt-detail.vue?vue&type=style&index=0&id=7f1724f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1724f6",
  null
  
)

export default component.exports